<template>
  <v-container fluid class="pa-0 bg-white position-relative">
    
    <!-- Selector de Idioma situado en la parte superior derecha -->
    <div class="language-selector">
      <v-select
        v-model="$i18n.locale"
        :items="langs"
        item-title="title"
        item-value="value"
        prepend-inner-icon="mdi-translate"
        variant="solo"
        density="compact"
        hide-details
        rounded="pill"
        class="elevation-2"
        style="width: 150px"
      ></v-select>
    </div>

    <v-row no-gutters class="hero-section py-16 px-6 px-md-16 align-center">
      <v-col cols="12" md="6" class="pr-md-10">

        <!--
        <div class="logo-container mb-6">
          <v-img src="../assets/simulart.svg" max-width="300" alt="Logo SimularT" contain></v-img>
        </div>
        -->

        <div class="logo-container mb-6">
            <!-- Enlace nativo forzado a comportarse como un contenedor visible -->
            <a 
              href="https://simulart.es" 
              target="_blank" 
              rel="noopener noreferrer" 
              style="display: block; width: fit-content; text-decoration: none;"
            >
              <v-img 
                src="../assets/simulart.svg" 
                max-width="300" 
                width="300" 
                alt="Logo SimularT" 
                contain
              ></v-img>
            </a>
          </div>

        <p class="text-subtitle-2 font-weight-bold text-success mb-2">
          {{ $t('hero.overline') }}
        </p>
        
        <h1 class="text-h2 font-weight-black text-secondary mb-6 leading-tight">
          {{ $t('hero.title') }}
        </h1>

        <v-btn
          color="secondary"
          size="x-large"
          variant="elevated"
          class="rounded-pill px-8"
          href="#proxima-seccion"
        >
          {{ $t('hero.cta') }}
          <v-icon end>mdi-chevron-down</v-icon>
        </v-btn>
      </v-col>
      
      <v-col cols="12" md="6" class="position-relative mt-10 mt-md-0">
        <v-img 
          src="../assets/imagen_informe.jpg" 
          class="dashboard-preview elevation-12 rounded-lg"
        ></v-img>
      </v-col>
    </v-row>

    <!-- Resto del contenido (Features, Steps, etc.) se mantiene igual -->
    <v-row id="proxima-seccion" justify="center" class="py-16 px-6 text-center">
      <v-col cols="12" class="mb-12">
        <h2 class="text-h4 font-weight-bold text-secondary">{{ $t('features.title') }}</h2>
        <p class="text-grey-darken-1">{{ $t('features.subtitle') }}</p>
      </v-col>

      <v-col v-for="(feat, i) in features" :key="i" cols="12" sm="6" md="2">
        <v-card variant="tonal" color="secondary" class="pa-6 h-100 rounded-lg border-opacity-25">
          <v-icon size="32" class="mb-4">{{ feat.icon }}</v-icon>
          <p class="text-body-1 text-secondary mb-0" v-html="$t(`features.items.${feat.key}`)"></p>
        </v-card>
      </v-col>
    </v-row>

    <v-row no-gutters class="py-16 px-6 text-center justify-center bg-grey-lighten-4">
      <v-col cols="12" class="mb-12">
        <h2 class="text-h4 font-weight-bold text-secondary">{{ $t('steps.title') }}</h2>
        <p class="text-grey-darken-1">{{ $t('steps.subtitle') }}</p>
      </v-col>
      <v-col cols="12" md="11">
        <div class="steps-container">
          <div v-for="(step, i) in steps" :key="i" class="step-item">
            <div class="step-icon-wrapper">
              <div class="step-number">{{ i + 1 }}</div>
              <v-avatar color="white" size="80" class="elevation-2">
                <v-icon :icon="step.icon" color="success" size="32"></v-icon>
              </v-avatar>
            </div>
            <div class="mt-4 px-2">
              <div class="font-weight-bold text-secondary mb-1" style="font-size: 0.9rem;">
                {{ $t(`steps.items.${step.key}.title`) }}
              </div>
              <div class="text-caption text-grey-darken-1">
                {{ $t(`steps.items.${step.key}.desc`) }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="px-6 py-16 justify-center">
      <v-col cols="12" md="10">
        <v-card color="#001e3c" dark class="pa-10 rounded-xl d-flex flex-column flex-md-row align-center justify-space-between">
          <div class="d-flex align-center mb-6 mb-md-0">
            <v-icon icon="mdi-compass-outline" size="64" color="success" class="mr-6"></v-icon>
            <div class="text-left">
              <h3 class="text-h4 font-weight-bold text-white mb-2">{{ $t('footer_cta.title') }}</h3>
              <p class="text-body-2 text-grey-lighten-1 mb-0">{{ $t('footer_cta.desc') }}</p>
            </div>
          </div>
          <v-btn color="primary" size="x-large" flat rounded="pill" append-icon="mdi-arrow-right" to="/catalogo">
            <span class="w-100 text-center">{{ $t('footer_cta.btn') }}</span>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    langs: [
      { title: 'Español', value: 'es' },
      { title: 'English', value: 'en' }
    ]
  }),

  created() {
    // Forzamos el idioma por defecto a inglés al cargar el componente
    this.$i18n.locale = 'en';
  },

  computed: {
    features() {
      return [
        { icon: 'mdi-earth', key: 'reports' },
        { icon: 'mdi-update', key: 'updates' },
        { icon: 'mdi-account-edit', key: 'custom' },
        { icon: 'mdi-chart-timeline-variant', key: 'longterm' },
        { icon: 'mdi-shield-check', key: 'model' }
      ]
    },
    steps() {
      return [
        { icon: 'mdi-map-marker-radius', key: 'areas' },
        { icon: 'mdi-chart-gantt', key: 'granularity' },
        { icon: 'mdi-layers-outline', key: 'scenarios' },
        { icon: 'mdi-file-send-outline', key: 'request' },
        { icon: 'mdi-download-lock-outline', key: 'download' }
      ]
    }
  }
}
</script>

<style scoped>
.language-selector {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
}

.text-secondary { color: #001e3c !important; }
.text-success { color: #00c853 !important; }
.leading-tight { line-height: 1.2 !important; }
.hero-section { background: linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%); }
.dashboard-preview { box-shadow: 0 24px 48px rgba(0,0,0,0.1); border: 1px solid rgba(0,0,0,0.05); }

.steps-container { display: flex; justify-content: space-between; position: relative; }
.step-item { flex: 1; position: relative; z-index: 1; }
.step-icon-wrapper { position: relative; display: inline-block; }
.step-number { position: absolute; top: -5px; right: -5px; background: #00c853; color: white; width: 24px; height: 24px; border-radius: 50%; font-size: 12px; display: flex; align-items: center; justify-content: center; z-index: 2; font-weight: bold; }
.steps-container::after { content: ""; position: absolute; top: 40px; left: 5%; right: 5%; height: 1px; border-top: 2px dotted #ccc; z-index: 0; }

@media (max-width: 960px) {
  .steps-container { flex-direction: column; gap: 40px; }
  .steps-container::after { display: none; }
  .language-selector { top: 10px; right: 10px; }
}
</style>